<template>
<div class="home shadow px-4 py-4 rounded">
    <div>
        <div v-if="!notifications.length > 0">
            <img src="~@/assets/icons/empty.svg" class="mx-auto" style="width: 50%; height: 50%;" />
            <p class="text-center m-5 bold">
                You currently have no new Notification
            </p>
        </div>
        <div v-else>
            <notify v-for="notification in notifications" :key="notification.id" :data="notification" />
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
export default {
    name: "notifications-page",
    components: {
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
        cartItem: () => import("@/components/learner/cartItem"),
        Notify: () => import("@/components/general/notify.vue"),
    },
    data() {
        return {
            notifications: [],
        };
    },
    computed: {
        items() {
            return [];
            return Object.values(this.cart);
        },
    },
    methods: {
        ...mapActions(["fetchNotification"]),
        ...mapMutations(["updateLoader"]),
    },
    async mounted() {
        this.updateLoader(true);
        this.notifications = await this.fetchNotification();
        this.updateLoader(false);
    },
};
</script>
